export default __webpack_public_path__ + "static/emoji-icon-9d1cab40180a10535859ec3709a183a9.png";